(() => {
  // The legacy storage path belongs to Wonder Flavours. Do not rewrite assets
  // from another Shopify store, Shopify services or a review provider.
  const storagePath = '/s/files/1/1263/2961/';
  const mediaPath = /^(?:files|products|collections|articles)\//;
  const srcsetPath = /(^|[\s,])((?:https?:)?\/\/cdn\.shopify\.com\/[^\s,]+)/gi;
  const attributes = ['src', 'srcset', 'poster', 'data-src', 'data-srcset'];
  const selector = 'img, picture source, video[poster]';

  function url(value) {
    if (typeof value !== 'string' || !value || !value.includes(storagePath)) return value;
    try {
      const resource = new URL(value, location.href);
      if (resource.hostname !== 'cdn.shopify.com' || resource.username || resource.password ||
          !/^https?:$/.test(resource.protocol) || !resource.pathname.startsWith(storagePath)) return value;
      const path = resource.pathname.slice(storagePath.length);
      if (!mediaPath.test(path)) return value;
      return location.origin + '/cdn/shop/' + path + resource.search + resource.hash;
    } catch { return value; }
  }

  function srcset(value) {
    return value.replace(srcsetPath, (_, before, resource) => before + url(resource));
  }

  function updateAttribute(element, attribute) {
    const original = element.getAttribute(attribute);
    if (!original || !original.includes(storagePath)) return;
    const next = attribute.endsWith('srcset') ? srcset(original) : url(original);
    if (next !== original) element.setAttribute(attribute, next);
  }

  function update(element) {
    attributes.forEach(attribute => updateAttribute(element, attribute));
  }

  function scan(root) {
    if (root.nodeType === 1 && root.matches(selector)) update(root);
    if (!root.firstElementChild) return;
    root.querySelectorAll?.(selector).forEach(update);
  }

  window.wfStorefrontMedia = { url };
  scan(document);
  const pending = new Set();
  let scheduled = false;
  new MutationObserver(mutations => {
    const changed = new Map();
    for (const mutation of mutations) {
      // Attribute changes affect this media element, never its descendants.
      if (mutation.type === 'attributes') {
        let names = changed.get(mutation.target);
        if (!names) changed.set(mutation.target, names = new Set());
        names.add(mutation.attributeName);
      }
      else mutation.addedNodes.forEach(node => { if (node.nodeType === 1) pending.add(node); });
    }
    changed.forEach((names, element) => {
      if (!element.isConnected || !element.matches(selector)) return;
      names.forEach(name => updateAttribute(element, name));
    });
    if (scheduled || !pending.size) return;
    scheduled = true;
    queueMicrotask(() => {
      const roots = new Set(pending);
      pending.clear();
      scheduled = false;
      roots.forEach(root => {
        if (!root.isConnected) return;
        // A section and its nested additions can arrive in the same batch.
        // Scan their highest inserted ancestor once.
        for (let parent = root.parentElement; parent; parent = parent.parentElement) {
          if (roots.has(parent)) return;
        }
        scan(root);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: attributes });
})();
